import {
    ADD_ANNOUNCEMENT_BY_TYPE,
    ADD_ANNOUNCEMENT_FOR_DAMAGE,
    DELETE_ANNOUNCEMENT_BY_CODE,
    SET_ANNOUNCEMENTS,
    WRAP_VEHICLE_COLOR_NOT_SELECTED
} from "./dispatchTypes";
import {showSuccessMessage} from "./globalDisplayActions";
import {STRUCTURAL_DAMAGE_ITEMS} from "../utils/structuralDamageItems";

export const setAnnouncements = (announcements) => async (dispatch, getState) => {
    dispatch({
        type: SET_ANNOUNCEMENTS,
        payload: {
            announcements: announcements,
        }
    })
}

export const addAnnouncement = (type, text) => dispatch => {
    dispatch({
        type: ADD_ANNOUNCEMENT_BY_TYPE,
        payload: {text: text, type: type}
    });
    dispatch(showSuccessMessage('announcement'));
};

export const addAnnouncementByCode = (type, code, text) => (dispatch, getState) => {
    dispatch({
        type: ADD_ANNOUNCEMENT_BY_TYPE,
        payload: {type: type, code: code, text: text}
    });
    dispatch(showSuccessMessage('announcement'));
};

export const addAnnouncementForDamage = (damage) => dispatch => {
    const longDamageKey = `${damage.itemCode}-${damage.subItemCode}-${damage.damageCode}-${damage.severityCode}`;
    const isStructuralDamage = STRUCTURAL_DAMAGE_ITEMS.includes(longDamageKey);
    
    if (isStructuralDamage) {
        dispatch({
            type: ADD_ANNOUNCEMENT_FOR_DAMAGE,
            payload: damage
        });
        dispatch(showSuccessMessage('announcement'));
    }
};

export const deleteAnnouncementByCode = (type, code) => dispatch => {
    dispatch({
        type: DELETE_ANNOUNCEMENT_BY_CODE,
        payload: {type: type, code: code}
    })
};

export const wrapVehicleColorNotSelected = (selected) => (dispatch) => {
    dispatch({
        type: WRAP_VEHICLE_COLOR_NOT_SELECTED,
        payload: selected
    })
}